import { API_ENDPOINT, AUTHORIZATION_CODE } from "../constants";

export const getCountry = () => {
  return fetch(`${API_ENDPOINT}/get-country-codes`, {
      method: 'post',
  })
      .then((data) => data.json())
      .then( res => res);
}


export const login = (contact, country_code, otp='', is_whatsapp_allow=0 ) => {
    let formData = new FormData();
      formData.append("contact", contact);
      formData.append("country_code", country_code);
      formData.append("is_whatsapp_allow", is_whatsapp_allow);
      formData.append("otp", otp);

    return fetch(`${API_ENDPOINT}/login-user`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then( res => res);
}

export const sendOtp = (contact, country_code, is_whatsapp_allow=0) => {
    let formData = new FormData();
      formData.append("contact", Number(contact));
      formData.append("country_code", Number(country_code));
      formData.append("is_whatsapp_allow", is_whatsapp_allow);

    return fetch(`${API_ENDPOINT}/send-otp`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then( res => res);
}

export const makeExistingUserGuest = (api, event_id, selfie_url) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("selfie_url", selfie_url);

    return fetch(`${API_ENDPOINT}/make-me-guest`, {
        method: 'post',
        body:formData
    })
        .then((data) => data.json())
        .then( res => res);
}

export const makeNewUserGuest = (event_id, selfie_url, contact, otp, country_code, is_whatsapp_allow) => {
    let formData = new FormData();
      formData.append("event_id", event_id);
      formData.append("selfie_url", selfie_url);
      formData.append("contact", contact);
      formData.append("otp", otp);
      formData.append("country_code", country_code);
      formData.append("is_whatsapp_allow", is_whatsapp_allow);

    return fetch(`${API_ENDPOINT}/make-me-guest`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then( res => res);
}



export const updateSelfie = (api, event_id, guest_image) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("guest_image", guest_image);

    return fetch(`${API_ENDPOINT}/update-selfie`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then( res => res);
}